// Base URL for assets
// export const BASE_URL = 'http://localhost:8080/';
export const BASE_URL = 'https://buildring.asyouwishjewelry.com/';
// const retailer_id  = window.Builder_Data.retailer_id || ''; // Default data

const MetalColorShank = {
  "White Gold":"gold-white.pmat",
  "Yellow Gold":"gold-yellow.pmat",
  "Rose Gold":"gold-rose.pmat",
  "SILVER":"gold-white.pmat",
  "Silver":"gold-white.pmat",
  "PLATINUM":"gold-white.pmat",
  "Platinum":"gold-white.pmat"
};

const FILTER_OPTION = {
  metal_type: {
    filter_value: "14K,18K,PLATINUM",
    filter_name: "Metal Type"
  },
  metal_color: {
    filter_value: "White Gold,Yellow Gold,Rose Gold,PLATINUM",
    filter_name: "Metal Color"
  },
  diamond_quality :{
    filter_value: "GHSI,FGVS,GHVSSI,LAB-GHVS",
    filter_name: "Choose Diamond Quality Code"
  },
  diamond_type:{
    filter_value:"Natural,Lab-Grown,Natural/Lab-Grown",
    filter_name: "Choose Diamond Type"
  },
  stone_shpe:{
    filter_value:"Round,Cushion,Emerald,Princess,Oval,Pear,Marquise,Radiant",
    filter_name: "Stone Shape"
  },
  ring_category:{
    filter_value:"Most-Popular,Halo,Solitaire-Ring,Vintage,New",
    filter_name: "Ring Category"
  }
};

const FILTER_OPTION_ESTRELLA = {
  metal_type: {
    filter_value: "9Kt,14Kt,18Kt,PLATINUM",
    filter_name: "Metal Type"
  },
  metal_color: {
    filter_value: "White Gold,Yellow Gold,Rose Gold,PLATINUM",
    filter_name: "Metal Color"
  },
  diamond_quality :{
    filter_value: "GHSI,DFVS,LAB-FGSI,LAB-DFVS",
    filter_name: "Choose Diamond Quality Code"
  },
  diamond_type:{
    filter_value:"Natural,Lab-Grown,Natural/Lab-Grown",
    filter_name: "Choose Diamond Type"
  },
  stone_shpe:{
    filter_value:"Round,Cushion,Emerald,Princess,Oval,Pear,Marquise,Radiant",
    filter_name: "Stone Shape"
  },
  ring_category:{
    filter_value:"Most-Popular,Halo,Solitaire-Ring,Vintage,New",
    filter_name: "Ring Category"
  }
}
const MOTHER_STONE_LOOP = [{2:"",1:"2"},{3:"",2:"2",1:"3"},{4:"",3:"2",2:"3",1:"4"},{5:"",4:"2",3:"3",2:"4",1:"5"}]

const FAMILY_BUILDER_ICON_IMAGE = {
  "Layer 1":"assets/images/Buildring/head_white.png",
  "Layer 2":"assets/images/Buildring/head_white.png"
};

const Diamond_color ={
    "DIAMOND":"diamond.dmat",
    "DARK PURPLE_SIDE":"dark-purple.dmat",
    "R BLUE_SIDE":"blue.dmat",
    "LIGHT PURPLE_SIDE":"light-purple.dmat",
    "DARK BLUE_SIDE":"dark-blue.dmat",
    "R BLUE_SIDE":"r-blue.dmat",
    "GARNET RED_SIDE":"garnet-red.dmat",
    // "":"citrine-1.dmat",
    // "":"emerald.dmat",
    // "":"gem-tsavorit.dmat",
    "FOREST GREEN_SIDE":"forest-green.dmat",
    // "":"morganit.dmat",
    // "":"peridot.dmat",
    "DARK PINK_SIDE":"dark-pink.dmat",
    // "":"rhodolite-garnet.dmat",
    "RED_SIDE":"red.dmat",
    // "":"sapphire.dmat",
    // "":"sapphire-1.dmat",
    // "":"sapphire-green.dmat",
    "YELLOW_SIDE":"yellow.dmat",
    // "":"smoky-quartz.dmat",
    // "":"tansanit.dmat",
    // "":"topas.dmat",
    // "":"tourmalin-rose.dmat",
    // "":"yellow-diamond.dmat",
    "BLUE_SIDE":"zircon-blue.dmat",
    // "":"zircon-brown.dmat",
    // "":"zircon-cinnamon.dmat",
    "PERIDOT GREEN_SIDE":"peridot-green.dmat",
    // "RED_SIDE":"zircon-red.dmat",
    // "":"zircon-turquoise.dmat",
    "BLUE_SIDE":"diamond.dmat"
}
const Diamond_value = {
  "Diamond": "diamond.dmat",
  "Amethyst": "amethist-diamond.dmat",
  "Aquamarine": "aquamarine.dmat",
  "BlackDiamond": "black-diamond.dmat",
  "BlueDiamond": "blue-diamond.dmat",
  "BrownDiamond": "brown-diamond.dmat",
  "Citrine": "citrine.dmat",
  "Citrine1": "citrine-1.dmat",
  "Emerald": "emerald.dmat",
  "Tsavorit": "gem-tsavorit.dmat",
  "GreenDiamond": "green-diamond.dmat",
  "Morganit": "morganit.dmat",
  "Peridot": "peridot.dmat",
  "PinkDiamond": "pink-diamond.dmat",
  "RhodoliteGarnet": "rhodolite-garnet.dmat",
  "Ruby": "ruby.dmat",
  "Sapphire": "sapphire.dmat",
  "Sapphire1": "sapphire-1.dmat",
  "Sapphiregreen": "sapphire-green.dmat",
  "Sapphirepink": "sapphire-pink.dmat",
  "Sapphireyellow": "sapphire-yellow.dmat",
  "Smokyquartz": "smoky-quartz.dmat",
  "Tansanit": "tansanit.dmat",
  "Topas": "topas.dmat",
  "TourmalinRose": "tourmalin-rose.dmat",
  "YellowDiamond": "yellow-diamond.dmat",
  "ZirconBlue": "zircon-blue.dmat",
  "ZirconBrown": "zircon-brown.dmat",
  "ZirconCinnamon": "zircon-cinnamon.dmat",
  "ZirconGreen": "zircon-green.dmat",
  "ZirconRed": "zircon-red.dmat",
  "ZirconTurquoise": "zircon-turquoise.dmat",
  "ZirconWhite": "zircon-white.dmat",
  "ZirconYellow": "zircon-yellow.dmat"
}

export const CURRENCY_OPTIONS = [
    { value: 'Dollar', label: 'Dollar' },
    { value: 'CAD', label: 'Canadian Dollar (CAD)' },
    { value: 'Euro', label: 'Euro' },
    { value: 'Lev', label: 'Bulgarian Lev' },
];

export const STONE_SIZE_OPTIONS = ["0.50", "0.75", "1.00", "1.25", "1.50", "1.75", "2.00", "2.50", "3.00", "3.50", "4", "5", "6", "7", "8"];
export const STONE_SIZE_MARKS = STONE_SIZE_OPTIONS.reduce((acc, val, idx) => { acc[idx] = val; return acc; }, {});

// Image sources
export const CONSTANT  = {
    BASE_URL: `${BASE_URL}`,
    RETAILER_ID : '3',
    MetalColorShank:MetalColorShank,
    Diamond_color:Diamond_color,
    MOTHER_STONE_LOOP:MOTHER_STONE_LOOP,
    FILTER_OPTION:FILTER_OPTION,
    Diamond_value:Diamond_value,
    FILTER_OPTION_ESTRELLA:FILTER_OPTION_ESTRELLA
};